import { ProjectManagementProjectsListPageDuplicateProjectModalPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import DuplicateProjectModal from 'modules/project_management/components/modals/DuplicateProjectModal'

const DuplicateProjectModalPage = () => {
  const { data: policies, loading: loadingPolicies } = useQuery(
    ProjectManagementProjectsListPageDuplicateProjectModalPageDocument
  )

  if (loadingPolicies) return null

  const canCreateProject = policies?.projectManagement._policies.projectCreate.can || false
  if (!canCreateProject) return null

  const canCreateSubproject = policies?.projectManagement._policies.subprojectManage.can || false
  const canAssignEmployees = policies?.projectManagement._policies.projectManage.can || false

  return (
    <DuplicateProjectModal
      canCreateSubproject={canCreateSubproject}
      canAssignEmployees={canAssignEmployees}
    />
  )
}

export default DuplicateProjectModalPage
